var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 160,
    width: 704,
    height: 704,
    rx: 160,
    ry: 160,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 80
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 700,
    width: 140,
    height: 60,
    rx: 30,
    ry: 30,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBox);
export default __webpack_public_path__ + "static/media/ic_box.9389a9a5a596723bc42b4bcc4be85eee.svg";
export { ForwardRef as ReactComponent };